import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { AuthenticationService } from "../../../../../auth/service";
import { Location } from "@angular/common";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IResidualAbsence } from "app/auth/models/absences";

@Component({
  selector: "app-residual-absences-list",
  templateUrl: "./residual-absences-list.component.html",
  styleUrls: ["./residual-absences-list.component.scss"],
})
export class ResidualAbsencesListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKey: string;
  private absencesResidualList: IResidualAbsence[] = [];
  public loadingTable: boolean = true;
  public columnKey: Array<string> = [];
  public insert_results: {
    result: {
      message: string;
      valid: string[];
      invalid: string[];
    };
    navigationId: number;
  };

  constructor(
    public _utilService: UtilsService,
    public _absencesService: AbsencesService,
    public _authenticationService: AuthenticationService,
    private route: Location,
  ) {}

  async ngOnInit() {
    this.columnKey = ["complete_name", "fiscal_code", "residual_holidays", "residual_permissions"];
    this.contentHeader = {
      headerTitle: "MENU.LIST_RESIDUAL_ABSENCES",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.LIST_RESIDUAL_ABSENCES",
            isLink: false,
          },
        ],
      },
    };

    this.absencesResidualList = await this._absencesService.getResidualAbsences();

    if (Object.keys(this.route.getState()).includes("result")) {
      this.insert_results = Object.values(this.route.getState())[Object.keys(this.route.getState()).indexOf("result")];
    }
  }

  getList() {
    let filtered: IResidualAbsence[] = this.absencesResidualList;

    if (this.searchKey) {
      filtered = filtered.filter((item: IResidualAbsence) => JSON.stringify(item).toLowerCase().includes(this.searchKey.toLowerCase()));
    }

    return filtered;
  }
}
